var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransistor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 74,
    viewBox: "0 0 37 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4081 9.82178C19.7639 9.82178 20.863 8.72249 20.863 7.36646C20.863 6.01042 19.7639 4.91113 18.4081 4.91113C17.0522 4.91113 15.9531 6.01042 15.9531 7.36646C15.9531 8.72249 17.0522 9.82178 18.4081 9.82178Z",
    fill: "#81D4A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.36621H2.45491V13.5045H0V7.36621Z",
    fill: "#81D4A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 7.36621H36.8299V13.5045H34.375V7.36621Z",
    fill: "#81D4A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4.91064H3.68238C4.36116 4.91064 4.90984 5.45941 4.90984 6.1383V14.7319C4.90984 15.4108 4.36116 15.9596 3.68238 15.9596H0V36.8298H36.8238V15.9596H33.1414C32.4626 15.9596 31.914 15.4108 31.914 14.7319V6.1383C31.914 5.45941 32.4626 4.91064 33.1414 4.91064H36.8238V0H0ZM18.4119 12.2766C15.7041 12.2766 13.5021 10.0742 13.5021 7.36596C13.5021 4.65774 15.7041 2.45532 18.4119 2.45532C21.1197 2.45532 23.3217 4.65774 23.3217 7.36596C23.3217 10.0742 21.1197 12.2766 18.4119 12.2766Z",
    fill: "#40336F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 46.6511H17.1806V73.6597H19.6355V46.6511H20.863V39.2852H15.9531V46.6511Z",
    fill: "#221E3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45312 46.6511H3.68058V73.6597H6.1355V46.6511H7.36296V39.2852H2.45312V46.6511Z",
    fill: "#221E3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4531 46.6511H30.6806V73.6597H33.1355V46.6511H34.363V39.2852H29.4531V46.6511Z",
    fill: "#221E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransistor);
export default __webpack_public_path__ + "static/media/transistor.b0fd7277cfe706d07e184f9912b05ad9.svg";
export { ForwardRef as ReactComponent };